var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 10,
    fill: "#32325D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2836 22.6201C60.2836 18.9386 58.473 16.0337 55.0123 16.0337C51.537 16.0337 49.4343 18.9386 49.4343 22.5914C49.4343 26.92 51.9167 29.1059 55.4796 29.1059C57.2172 29.1059 58.5314 28.7176 59.5243 28.1712V25.295C58.5314 25.7839 57.3924 26.0859 55.9468 26.0859C54.5304 26.0859 53.2747 25.597 53.114 23.9H60.2544C60.2544 23.7131 60.2836 22.9653 60.2836 22.6201ZM53.0702 21.254C53.0702 19.6289 54.0778 18.953 54.9977 18.953C55.8884 18.953 56.8376 19.6289 56.8376 21.254H53.0702Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7977 16.0339C42.3667 16.0339 41.4468 16.6955 40.9357 17.1556L40.7459 16.264H37.5334V33.0321L41.184 32.2699L41.1986 28.2002C41.7242 28.5741 42.4981 29.1062 43.7831 29.1062C46.3969 29.1062 48.777 27.0353 48.777 22.4766C48.7624 18.3061 46.3531 16.0339 43.7977 16.0339ZM42.9216 25.9424C42.0601 25.9424 41.549 25.6404 41.1986 25.2665L41.184 19.9312C41.5636 19.5141 42.0893 19.2265 42.9216 19.2265C44.2504 19.2265 45.1703 20.6933 45.1703 22.5772C45.1703 24.5043 44.265 25.9424 42.9216 25.9424Z",
    fill: "#F7F8F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5105 15.1852L36.1756 14.4087V11.4893L32.5105 12.2515V15.1852Z",
    fill: "#F7F8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1756 16.2782H32.5105V28.8615H36.1756V16.2782Z",
    fill: "#F7F8F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5827 17.3424L28.3491 16.2782H25.1951V28.8615H28.8456V20.3336C29.7071 19.2263 31.1673 19.4276 31.62 19.5858V16.2782C31.1527 16.1056 29.4443 15.7892 28.5827 17.3424Z",
    fill: "#F7F8F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2816 13.1575L17.7187 13.9053L17.7041 25.4244C17.7041 27.5528 19.3249 29.1203 21.486 29.1203C22.6834 29.1203 23.5595 28.9046 24.0414 28.6457V25.7264C23.5741 25.9134 21.267 26.5749 21.267 24.4465V19.3413H24.0414V16.2782H21.267L21.2816 13.1575Z",
    fill: "#F7F8F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4106 19.9309C11.4106 19.3701 11.8779 19.1543 12.6518 19.1543C13.7616 19.1543 15.1634 19.4851 16.2731 20.0747V16.6952C15.0611 16.2206 13.8638 16.0337 12.6518 16.0337C9.68759 16.0337 7.71631 17.5581 7.71631 20.1035C7.71631 24.0726 13.2651 23.4398 13.2651 25.1512C13.2651 25.8127 12.681 26.0284 11.8633 26.0284C10.6513 26.0284 9.1035 25.5395 7.87693 24.8779V28.3006C9.23492 28.8758 10.6075 29.1203 11.8633 29.1203C14.9005 29.1203 16.9886 27.6391 16.9886 25.0649C16.974 20.7794 11.4106 21.5416 11.4106 19.9309Z",
    fill: "#F7F8F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.4699965c9f747ddd4ba27ac948db26df.svg";
export { ForwardRef as ReactComponent };